<template>
  <div class="parent-container">
    <img class="micro-icon" src="../assets/icons/microphone.svg" />
    <div class="waveform-container">
      <canvas ref="waveformCanvas"></canvas>
    </div>
  </div>
</template>

  
  <script>
  import { isAIEnabled } from "@/_helpers/ai-features";

  export default {
    name: "VoiceWaveform",
    mounted() {
      // Only initialize audio visualizer if AI features are enabled
      if (isAIEnabled()) {
        this.initAudioVisualizer();
      } else {
        //console.log('AI features disabled - skipping audio visualizer');
      }
    },
    methods: {
      async initAudioVisualizer() {
        const canvas = this.$refs.waveformCanvas;
        const ctx = canvas.getContext("2d");
  
        canvas.width = window.innerWidth;
        canvas.height = 200;
  
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const analyser = audioContext.createAnalyser();
  
        const source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);
  
        analyser.fftSize = 2048;
        const bufferLength = analyser.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);
  
        const drawWaveform = () => {
          requestAnimationFrame(drawWaveform);
  
          analyser.getByteTimeDomainData(dataArray);
  
          ctx.clearRect(0, 0, canvas.width, canvas.height);
  
          ctx.lineWidth = 2;
          ctx.strokeStyle = "black";
          ctx.beginPath();
  
          const sliceWidth = (canvas.width * 1.0) / bufferLength;
          let x = 0;
  
          for (let i = 0; i < bufferLength; i++) {
            const v = dataArray[i] / 128.0;
            const y = (v * canvas.height) / 2;
  
            if (i === 0) {
              ctx.moveTo(x, y);
            } else {
              ctx.lineTo(x, y);
            }
  
            x += sliceWidth;
          }
  
          ctx.lineTo(canvas.width, canvas.height / 2);
          ctx.stroke();
        };
  
        drawWaveform();
      },
    },
  };

  </script>
  
  <style scoped>
.parent-container {
  flex-direction: flex;
  display: flex;
  justify-content: center; 
  align-items: center;    
  height: 100%;
  Width:100%;
  margin: 0;      
}

.waveform-container {
  width: 30%;
  height: 100%;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

canvas {
  display: block;
  width: 100%;
  height: 100%;
}
.micro-icon {
  width: 30px; 
  height: auto; 
  margin-bottom: 5px; 
}
  </style>
  